// extracted by mini-css-extract-plugin
var _1 = "Caret-module__block--CMlDZ";
var _2 = "Caret-module__caret--kHbSG";
var _3 = "Caret-module__down--dEyBs";
var _4 = "Caret-module__left--VuaZh";
var _5 = "Caret-module__right--y99Ew";
var _6 = "Caret-module__up--_r9Vb";
export { _1 as "block", _2 as "caret", _3 as "down", _4 as "left", _5 as "right", _6 as "up" }
